// Must stay the first import: it installs the unhandled-error listeners, and
// anything imported above it could throw before they exist.
import "./logging/earlyErrorCapture";
import { ThemeProvider } from "@bindery/ui/components/theme/theme-provider";
import { ConvexProvider } from "convex/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { settleGoogleAttempt } from "./auth/google-preference";
import { convex } from "./convex/client";
import { LoggerProvider } from "./logging";
import { startLocalStore } from "./sync";
import "./index.css";
import { registerServiceWorker } from "./registerServiceWorker";

settleGoogleAttempt(location);

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("index.html lost its #root");
createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider>
      <ConvexProvider client={convex}>
        <LoggerProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </LoggerProvider>
      </ConvexProvider>
    </ThemeProvider>
  </StrictMode>,
);

registerServiceWorker();
startLocalStore();
